import className from "classnames/bind";
import { useEffect, useRef, useState } from "react";
import { RadioButton } from "../../FormComponents";
import { useTicketing } from "../TicketingProvider";
import CalendarIcon from '@/assets/svg/calendar.svg';

import { DayPicker } from "react-day-picker";
import "react-day-picker/style.css";

import { DateTime } from "luxon";

import styles from "./TicketingForm.module.scss";
const cx = className.bind(styles);

export default function StepOne() {
  const {
    data: { step1Label, todayLabel, tomorrowLabel, anotherDateLabel },
    isFutureDate,
    handleDateChange,
    dateOpt,
    today,
    dateCopy,
    setIsFutureDate,
  } = useTicketing();
  const datePickerRef = useRef<HTMLDivElement | null>(null);
  const [pickerOpen, setPickerOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState<Date>();
  const [month, setMonth] = useState<Date>(new Date());

  const checkClickOutside = (e: MouseEvent) => {
    const target = e.target as HTMLElement;
    const targetClasses = target.classList.toString();
    const targetParent = target.parentElement;
    const parentClasses = targetParent?.classList.toString() || '';
    const isCalendar = targetClasses.includes('rdp-root') || parentClasses.includes('rdp-root');
    if (datePickerRef.current && !datePickerRef.current.contains(target) && !isCalendar) {
      setPickerOpen(false);
      window.removeEventListener('click', checkClickOutside);
    }
  }

  const handleShowPicker = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (pickerOpen) {
      setPickerOpen(false);
    } else {
      setPickerOpen(true);
      setIsFutureDate(true);
      window.addEventListener('click', checkClickOutside);
    }
  };

  const handlePickerSelect = (date?: Date) => {
    if (date) {
      setSelectedDate(date);
      setMonth(date);
      setPickerOpen(false);
    }
  };

  useEffect(() => {
    if (selectedDate && isFutureDate) {
      const isoDate = DateTime.fromJSDate(selectedDate as Date).setZone("America/New_York").toISODate();
      handleDateChange(isoDate, true);
    }
  }, [selectedDate]);

  return (
    <div className={cx(["step", "step-one"])}>
      <div className={cx("step__copy")}>
        <p className={cx(["step-label", "text-l"])}>{step1Label}</p>
      </div>
      <div className={cx("date-options")}>
        <RadioButton
          className={cx("day-select")}
          active={dateOpt === "today" && !isFutureDate}
          label={todayLabel}
          onClick={handleDateChange}
          value="today"
        />
        <RadioButton
          className={cx("day-select")}
          active={dateOpt === "tomorrow" && !isFutureDate}
          label={tomorrowLabel}
          onClick={handleDateChange}
          value="tomorrow"
        />
        <div className={cx("date-picker")} ref={datePickerRef}>
          <button
             className={cx("date-select", { active: isFutureDate })}
             type="button"
             onClick={handleShowPicker}
           >
             <span className="text-m">{isFutureDate && dateCopy ? dateCopy : anotherDateLabel}</span>
             <CalendarIcon className={cx("icon")} />
          </button>
          {pickerOpen && (
            <DayPicker
              mode="single"
              selected={selectedDate}
              onSelect={handlePickerSelect}
              month={month}
              onMonthChange={setMonth}
              disabled={[
                { before: new Date() },
                { after: DateTime.fromISO(today).plus({ years: 1 }).toJSDate() }
              ]}
            />
          )}
        </div>
      </div>
    </div>
  );
}
